// extracted by mini-css-extract-plugin
export var linkText = "_ms-0";